var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pb-0",attrs:{"cols":"12","xs":"12","sm":"10","md":"6"}},[_c('p',{staticClass:"headline font-weight-light"},[_vm._v("Gerät")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }